import React, { useEffect, useRef, useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo11 } from "../../../routes/Module11";
import Sidebar from "../Sidebar";
import {
  faSignLanguage,
  faPen,
  faEraser,
} from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo11/puesto.png";
import Imagen2 from "../../../images/modulo11/protesta.png";
import Imagen3 from "../../../images/modulo11/hablarjuez.png";
import Imagen4 from "../../../images/modulo11/laberinto.png";
import Imagen4M from "../../../images/modulo11/laberinto-mobile.png";
import Imagen5 from "../../../images/modulo11/mercadoclausurado.png";
import GuiaDocente from "../../../components/GuiaDocente";
import { ReactSketchCanvas } from "react-sketch-canvas";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo11/Actividad 10.mp3";

const styles = {
  height: "100%",
  background: `transparent`,
  minHeight: 320
};

const Actividad9 = () => {
  const [eraseMode, setEraseMode] = useState(false);
  const [penMode, setPenMode] = useState(true);
  const infoUnidad = modulo11.content[0];
  const infoAct = modulo11.content[0].activities[9];
  const crumbs = [
    {
      title: modulo11.title,
      url: "/" + modulo11.url,
    },
    {
      title:
        modulo11.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo11.content[0].activities[8].name}`,
    linkPrev: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[8].path}`,
    titleNext: `${modulo11.content[0].activities[10].name}`,
    linkNext: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[10].path}`,
  };
  const metadata = {
    color: modulo11.color,
    title: `${modulo11.title} - ${infoAct.name}`,
    name: modulo11.title,
  };

  const canvasEl = useRef(null);
  const activateEraser = () => {
    setEraseMode(!eraseMode);
    setPenMode(eraseMode);
  };
  const activatePen = () => {
    setPenMode(!penMode);
    setEraseMode(penMode);
  };
  useEffect(() => {
    if (eraseMode) {
      canvasEl.current.eraseMode(true);
    } else {
      canvasEl.current.eraseMode(false);
    }
  }, [eraseMode]);
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo11.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="mb-0">
        <li>
          Syndi Sangama tiene un puesto de frutas en el mercado. Su puesto está
          muy limpio y Syndi respeta las normas de seguridad de la
          Municipalidad. No ocurre lo mismo con los demás puestos del mercado:
          tienen basura acumulada y los cajones de frutas tapan las salidas. Por
          ello, la Municipalidad ha cerrado el mercado. Syndi ha hecho varios
          reclamos en la Municipalidad.
        </li>
        <li>
          ¿Qué puede hacer Syndi ante esa situación? Lee las tres opciones y
          traza con una línea el camino que lleva desde el mercado a la opción
          correcta.
        </li>
      </ul>

      <div className="row mt-5 px-md-5 g-0">
        <div className="col-lg-3 col-12 d-lg-block d-flex flex-row align-items-end">
          <div>
            <div className="text-center">Abre su puesto</div>
            <img src={Imagen1} alt="Electores" className="img-fluid w-200" />
          </div>
          <div>
            <div className="text-center mt-4">Organiza protesta</div>
            <img src={Imagen2} alt="Electores" className="img-fluid w-200" />
          </div>
          <div>
            <div className="text-center mt-4">Acude al Poder Judicial</div>
            <img src={Imagen3} alt="Electores" className="img-fluid w-200" />
          </div>
        </div>
        <div className="col-lg-7 col-12 pt-5 position-relative">
          <div
            className="laberinto-desktop"
            style={{
              height: "680px",
              background: `url(${Imagen4})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100%",
              marginTop: "6rem",
            }}
          ></div>
          <div
            className="laberinto-mobile"
            style={{
              height: "280px",
              background: `url(${Imagen4M})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
              margin: "0 !important",
            }}
          ></div>
          <ReactSketchCanvas
            ref={canvasEl}
            style={styles}
            width="500"
            height="100%"
            strokeWidth={4}
            strokeColor="red"
          />
        </div>
        <div className=" col-lg-2 col-12 position-relative">
          <img src={Imagen5} alt="Electores" className="img-mercado" />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-10 col-12 px-5">
          <div className="d-flex mt-1 justify-content-end w-100">
            <button
              onClick={activateEraser}
              className={`btn btn-green me-1 ${
                eraseMode ? "active" : "inactive"
              }`}
            >
              Borrador <FontAwesomeIcon icon={faEraser} />
            </button>
            <button
              onClick={activatePen}
              className={`btn btn-green me-1 ${
                penMode ? "active" : "inactive"
              }`}
            >
              Lapiz <FontAwesomeIcon icon={faPen} />
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y observen las viñetas Ayude a resolver la
          actividad. Explique por qué, a pesar que hay decisiones que pueden ser
          injustas, se debe respetar la ley. El Poder Judicial es el encargado
          de defender a los ciudadanos cuando hay una medida que atenta contra
          nuestros derechos.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
